var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toolbox-footer"},[_c('v-btn',{staticClass:"sr-button",attrs:{"text":"","loading":_vm.loading,"disabled":_vm.loading},on:{"click":function($event){return _vm.save()}}},[_vm._v("\n        Speichern\n    ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }